export enum GraphScale {
  Linear = "linear",
  Percent = "percent",
}
